// extracted by mini-css-extract-plugin
module.exports = {"switch":"br_bB","switchBg":"br_gr","switchLabel":"br_gs","switchTab":"br_bG","active":"br_bH"};